import { loadableWithFallback } from '@vision/ui/utils';
import type { BarChart3Props } from './BarChart3';

export const BarChart3 = loadableWithFallback<BarChart3Props>(() => import('./BarChart3'));
